import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {VenueDetails} from './venue-add-details.model';
import {RxComponent} from 'app/core/components/common/rx.component';
import {ConfigService} from 'app/core/services/config.service';
import {FormService} from 'app/shared/components/form/form.service';
import {NotificationService} from 'app/core/services/notification.service';

@Component({
    selector: 'itpx-venue-add',
    templateUrl: './venue-add.component.html',
    styleUrls: ['./venue-add.component.css', '../base.css']
})
export class VenueAddComponent extends RxComponent implements OnInit {

    private details: VenueDetails = new VenueDetails();
    private saveUrl: string;
    private guidances = {
        'name' : 'venues.fields.name.guidance',
        'room' : 'venues.fields.room.guidance',
        'address' : 'venues.fields.address.guidance',
        'city' : 'venues.fields.city.guidance',
        'state' : 'venues.fields.state.guidance',
        'province' : 'venues.fields.province.guidance',
        'country' : 'venues.fields.country.guidance',
        'postalCode' : 'venues.fields.postalCode.guidance',
    };

    constructor(
                private configService: ConfigService,
                private formService: FormService,
                private notificationService: NotificationService,
                private router: Router) {
        super();
    }

    ngOnInit() {
        this.saveUrl = this.configService.get('server').url + this.configService.get('endpoints').solar.address.add.api;
    }

    onSubmit() {
        this.formService.save(this.details, this.saveUrl)
            .subscribe(
                data => {
                    this.notificationService.success('Successfully saved the data', 'Success');
                    this.onSaveFinished(data);
                }
            );
    }

    private onSaveFinished(event) {
        this.router.navigate(['/organization/venues']);
    }

    cancel() {
        this.router.navigate(['organization', 'venues']);
    }

}



// WEBPACK FOOTER //
// ./src/app/organization/components/venues/components/add/venue-add.component.ts